"use client";

import { useMatchingLocaleContext } from "../../helpers/LocaleStringContext";
import { getIndiaLegalCopy } from "../../helpers/getIndiaLegalCopy";
import { getProductVersionContainsSugar } from "../../helpers/getProductVersionContainsSugar";
import { RedBullVersion } from "../../helpers/redBullVersion";
import { CosmosText, CosmosTextProps } from "@cosmos/web-react";
import classNames from "classnames/bind";
import styles from "./LegalDisclaimerBannerIndia.module.css";

const cx = classNames.bind(styles);

const DisclaimerText = ({
  size,
  appearance,
  spacing,
  children,
}: {
  size: CosmosTextProps["size"];
  appearance: CosmosTextProps["appearance"];
  spacing?: CosmosTextProps["spacing"];
  children: string;
}) => (
  <CosmosText
    size={size}
    appearance={appearance}
    kind="subtle"
    spacing={spacing}
    className={cx("text")}
  >
    {children}
  </CosmosText>
);

export const LegalDisclaimerBannerIndia = ({
  size = "x-small",
  appearance = "dark",
  redBullVersion,
  className,
}: {
  size?: CosmosTextProps["size"];
  appearance?: CosmosTextProps["appearance"];
  redBullVersion: RedBullVersion;
  className?: string;
}) => {
  const matchingLocale = useMatchingLocaleContext();

  if (matchingLocale?.legalDisclaimer !== "in") {
    return null;
  }

  const copy = getIndiaLegalCopy(matchingLocale.lang);
  const containsSugar = getProductVersionContainsSugar(redBullVersion);

  return (
    <div className={cx("container", className)}>
      <div className={cx("inner")}>
        {(containsSugar ? copy.sugar : copy.sugarFree).map(
          (paragraph, index) => (
            <DisclaimerText
              key={index}
              size={size}
              appearance={appearance}
              spacing={index > 0 ? "long-form-top" : undefined}
            >
              {paragraph}
            </DisclaimerText>
          ),
        )}
      </div>
    </div>
  );
};
